import * as types from '../mutation-types';
import { information } from '../../api';
// eslint-disable-next-line
import store from "../index";

const state = {
  news: [],
  faqs: [],
  detail: {},
  pagination: null,
  faqsPagination: null,
  process: [],
  charges: [],
};

const getters = {
  // eslint-disable-next-line
  getInformationDetail: (s) => (id) => {
    return s.detail.data;
  },
};

const actions = {
  fetchInformations({ commit }, params) {
    return information.get(params).then(({ data: response }) => {
      commit(types.RECEIVE_INFORMATIONS, { response, params });
    });
  },
  fetchInformationDetail({ commit }, id) {
    return information.getId(id).then(({ data: response }) => {
      commit(types.RECEIVE_INFORMATION_DETAIL, { data: response.data });
    });
  },
};

/* eslint no-param-reassign: 0, default-case: 0 */
const mutations = {
  [types.RECEIVE_INFORMATIONS](s, { response, params }) {
    switch (params.group_id) {
      case 2:
        s.news = [...response.data];
        s.pagination = response.meta.pagination;
        break;
      case 1:
        s.faqs = [...response.data];
        s.faqsPagination = response.meta.pagination;
        break;
      case 3:
        s.charges = [...response.data];
        break;
      case 14:
        s.process = [...response.data];
        break;
      default:
        store.dispatch('fetchInformationDetail', response.data[0].id);
        break;
    }
  },
  [types.RECEIVE_INFORMATION_DETAIL](s, data) {
    s.detail = data;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/information.js